import React from "react";
import { Link } from "react-router-dom";
import "./style.css"
const Breadcrumb = ({ crumbs }) => {
    // if (crumbs.length <= 1) {
    //     return null;
    // }
    return (
        <div>
            <div className="alert" style={{ fontWeight: '500' }}>
                <Link to="/" className="text-white">
                    <i className="fas fa-home" />
                </Link>
                {crumbs.map(({ name, path }, key) =>
                    key + 1 === crumbs.length ? (
                        <span key={key} className="text-white">
                            &nbsp;{name}
                        </span>
                    ) : (
                        <Link key={key} to={path} className="text-white">
                            &nbsp;{name} /
                        </Link>
                    )
                )}
            </div>
        </div>

    );
};
export default Breadcrumb;